const general = () => {
  var $ = jQuery.noConflict();
  $(document).ready(function () {
    $("html, body").animate(
      {
        scrollTop:
          $(".banner-sec__slider-img").offset().top -
          $(".main-header").outerHeight(true),
      },
      10,
    );
    var url = window.location.href;
    var hash = url.split("#")[1];
    if (hash) {
      setTimeout(function () {
        $("html, body").animate(
          {
            scrollTop:
              $("#" + hash).offset().top - $(".main-header").outerHeight(true),
            },
            300,
        );
      }, 400);
    }
  });
  $(window).resize(function () {
    //alert('topa');
    var header_height = $(".logo").outerHeight(true);
    var roundoff = Math.ceil(header_height);
    $(".desk > li").css("height", roundoff);
  });

  $(window).ready(function () {
    //$('input,textarea').placeholder();
    $(".enumenu_ul").responsiveMenu({
      menuIcon_text: "",
      menuslide_overlap: true,
      menuslide_direction: "right",
      onMenuopen: function () {},
    });
    $(".banner-slider").slick({
      dots: true,
      arrows: false,
      draggable: false,
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 4000,
      default: true,
      fade: true,
      speed: 1000,
      infinite: true,
      cssEase: "ease-in-out",
      touchThreshold: 100,
    });
    $(".search-part > a").click(function (e) {
      $(".search-form").toggleClass("search-form-active");
      $("body").toggleClass("search-form-open");
      e.stopImmediatePropagation();
    });
    $(".contact-sec i").click(function () {
      $(".contact-sec").toggleClass("contact-sec-active");
      $(".home-contact-form").slideToggle(800);
    });
    document.addEventListener(
      "wpcf7mailsent",
      function (event) {
        $(
          "<p>If you have provided your contact details, we will be in touch shortly to discuss your question, comments or suggestions.</p>",
        ).insertAfter(".wpcf7-mail-sent-ok");
      },
      false,
    );

    $(".patients-professionals-sec")
      .clone()
      .addClass("patients-professionals-mob")
      .insertAfter(".welcome-forest-sec");

    stickTheHeader();
    $(".enumenu_ul a").click(function () {
      // $('.mob').slideUp();
      var submithref = $(this).attr("href");
      submithref.substring(1);
      var url = submithref.substring(1),
        hash = url.split("#")[1];
      if (hash) {
        if (
          location.pathname.replace(/^\//, "") ==
            this.pathname.replace(/^\//, "") &&
          location.hostname == this.hostname
        ) {
          var target = $(this.hash);
          target = target.length
            ? target
            : $('[name="' + this.hash.slice(1) + '"]');
          console.log(target);
          $("html, body").animate(
            {
              scrollTop:
                target.offset().top - $(".main-header").outerHeight(true) - 40,
            },
            300,
          );
          return false;
        }
        window.location.href = submithref;
      } else if (typeof hash == "undefined") {
        var submithref = $(this).attr("href");
        console.log(submithref);
        window.location.href = submithref;
      }
    });
    headerHeight();
  });

  $(window).scroll(function () {
    stickTheHeader();
    headerHeight();
  });

  $(".pre-admission-title i").click(function (e) {
    $(this).parents(".pre-admission-title").toggleClass("admission-active");
    $(this)
      .parents(".pre-admission-title")
      .siblings(".patients-content")
      .slideToggle(800);
    e.preventDefault();
  });
  function stickTheHeader() {
    var myHeight = $(".main-header").outerHeight();

    if ($(window).scrollTop() > $(".main-header").outerHeight()) {
      //alert("I am an alert box!");
      $("body").addClass("stickHeader");
      $("body").css("padding-top", myHeight + "px");
      $(".blank-space").show();
    } else {
      $("body").removeClass("stickHeader");
      $(".blank-space").hide();
      $("body").removeAttr("style");
    }
  }

  function headerHeight() {
    var header_height = $(".logo").outerHeight(true);
    var roundoff = Math.ceil(header_height);
    $(".desk > li").css("height", roundoff);
  }

  $(document).ready(function () {
    $(".read-more-toggle").each(function () {
      $(this).click(function () {
        var elem = $(this);
        if (!elem.hasClass("is-active")) {
          //Stuff to do when button is in the read more state
          $(this).html("Read less");
          $(this).addClass("is-active");
          $(this).parent().find(".section__read-more-copy").slideDown();
        } else {
          //Stuff to do when button is in the read less state
          $(this).html("Read more");
          $(this).removeClass("is-active");
          $(this).parent().find(".section__read-more-copy").slideUp();
        }
      });
    });
  });

  // Exclusive accordions (details/summary): opening one closes the others in the same container
  document.addEventListener(
    "toggle",
    (event) => {
      if (event.target.tagName === "DETAILS") {
        const details = event.target;
        const container = details.parentElement;

        if (
          container &&
          container.classList.contains("accordion-exclusive") &&
          details.open
        ) {
          container.querySelectorAll("details").forEach((otherDetails) => {
            if (otherDetails !== details) {
              otherDetails.open = false;
            }
          });
        }
      }
    },
    true
  );

  // Anchor ID links: smoothly scroll just above to avoid cutting off content
  window.addEventListener("load", () => {
    function scrollToElement(event) {
      const elemID = event.currentTarget.getAttribute("href").substring(1);
      const elem = document.getElementById(elemID);

      if (elem) {
        const scrollPosition = elem.offsetTop - 150;

        window.scrollTo({
          top: scrollPosition,
          behavior: "auto",
        });

        event.preventDefault();
      }
    }

    const anchorElements = document.querySelectorAll('a[href^="#"]');

    for (let i = 0; i < anchorElements.length; i++) {
      anchorElements[i].addEventListener("click", scrollToElement);
    }
  });
};

export { general };
